{
  "products_sync_page": {
    "title": "Product Sync",
    "description": "This synchronises product data from your eCommerce platform.",
    "lookup_title": "Product Data Lookup",
    "lookup_description": "Search and diagnose the product data you're sending to SparkLayer.",
    "search_placeholder": "Search products by ID, name, description, barcode, variant SKU, or variant options",
    "actions": {
      "manual_sync": "Manually synchronise products"
    },
    "notifications": {
      "sync_started": "Product synchronisation started."
    }
  },
  "product_data_page": {
    "title": "Product Data",
    "description": "The product data SparkLayer holds for variant {sku}.",
    "not_found": "Sorry, no product was found for the variant SKU \"{sku}\". Please try searching again.",
    "troubleshooting_link": "Troubleshooting"
  }
}
